import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export const Sectors = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-brand-green to-brand-green-dark text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Áreas de Atividade
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Trabalhamos em diferentes sectores e contextos.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-600 leading-relaxed mb-12">
              Desenvolvemos soluções para entidades públicas e privadas em diferentes sectores: 
              edifícios institucionais, instalações desportivas, infraestruturas técnicas 
              e outros contextos que necessitem de sistemas integrados de gestão.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Cada projeto é analisado de forma individual para identificar as necessidades 
              específicas e desenhar a solução mais adequada ao contexto.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-slate-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">
              Quer Saber Mais?
            </h2>
            <p className="text-xl text-gray-300 mb-10 leading-relaxed">
              Entre em contacto para discutirmos o seu projeto.
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-brand-green hover:bg-brand-green-dark text-white px-10 transition-all duration-300 hover:scale-105">
                Pedir Contacto
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
